/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
    id: 'sb',
    extensions: ['.sb'],
    aliases: ['Small Basic', 'sb'],
    loader: function () { return import('./sb.js'); }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/basic-languages/sb/sb.contribution.js
// module id = 1297
// module chunks = 58